import styled, { css } from 'styled-components';
import { MapContainer } from "react-leaflet";


export const Wrapper = styled.div`
  height: 100%;
  position: relative;
`

export const StyledMapContainer = styled(MapContainer)`
  width: 100%;
  height: 100%;
  position: relative;
`

export const FooterMapContainer = styled.div`
  position: absolute;
  bottom: 0;
  z-index: 999;
  width: 100%;
  padding: 24px;
`

export const LayerButtonContainer = styled.div`
  padding: 24px;
  position: absolute;
  top: 0;
  right: 0;
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  justify-content: flex-end;
  z-index: 999;

  > button {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 50px;
    height: 50px;
    border-radius: 6px;
    background-color: var(--black-100);
    margin-bottom: 0.5rem;

    &:hover {
      opacity: 0.8;
    }

    svg {
      path {
        stroke: var(--white);
        fill: transparent;
      }
    }
  }
`

export const HeatmapContainer = styled.div`
  display: flex;
  flex-direction: column;
  background-color: var(--black-100);
  border-radius: 6px;
  padding: 0.8rem;
  z-index: 999;

  h3 {
    font-size: 1rem;
  }

  label {
    margin-bottom: 0.5rem;
    margin-top: 0.5rem;
    color: var(--grey-100);
  }

  > button {
    padding: 0.5rem 1rem;
    background-color: var(--black-400);
    border-radius: 8px;
    font-family: Inter, sans-serif;
    font-size: 0.8rem;
    margin-bottom: 0.3rem;
    color: var(--white);

    &:hover {
      opacity: 0.8;
    }

    &.active {
      background-color: var(--primary);
      color: var(--black-100);
    }
  }
`

export const HeatmapHeader = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
`

export const CloseButton = styled.button`
  background-color: var(--black-400);
  padding: 0rem;
  width: 30px;
  height: 30px;
  border-radius: 100%;
  margin-left: 0.5rem;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: background 0.4s;

  &:hover {
    background-color: var(--black-100);
  }

  img {
    width: 20px;
    height: 20px;
  }
`

type props = {
  activeHeatmap?: Boolean;
}

export const ButtonActiveMap = styled.button<props>`
  ${({activeHeatmap}) => activeHeatmap && css`
  background-color: var(--primary);
      color: var(--black-100);
  `}
`

export const ClusterMarker = styled.span`
  display: flex;
  align-items: center;
  justify-content: center;
  border: 0.25rem solid rgba(241, 180, 12, 0.7);
  border-radius: 6rem;
  background-color: rgba(25, 25, 25, 0.85);
  font-size: 1rem;
  font-family: Inter, sans-serif;
`


